export const ERROR = 'error';
export const SUCCESS = 'success';



// WEBPACK FOOTER //
// ./src/constants/apiStatus.js